import { jsx as _jsx } from "react/jsx-runtime";
function EnterIcon() {
    return (_jsx("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: _jsx("path", { d: "M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5" }) }));
}
function ExitIcon() {
    return (_jsx("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2.4", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true", children: _jsx("path", { d: "M9 4v5H4M20 9h-5V4M15 20v-5h5M4 15h5v5" }) }));
}
/**
 * The Top Bar's full-screen toggle, beside the Settings gear (user decision
 * 2026-10-04). Corners outward to enter, inward to leave. Same round shell and
 * 44px tap area as the gear; rendered only where the host permits full screen.
 */
export function GameFullscreenButton({ active, onClick, ariaLabel }) {
    return (_jsx("button", { type: "button", className: "game-fullscreen-btn", onClick: onClick, "aria-label": ariaLabel, "aria-pressed": active, "data-testid": "game-fullscreen-btn", children: active ? _jsx(ExitIcon, {}) : _jsx(EnterIcon, {}) }));
}
